export default "__VITE_ASSET__BdMhntgJ__"